import { Phone, Mail, Facebook, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
    return (
        <div>
            <section className="py-16 lg:py-24" style={{ background: "linear-gradient(160deg,#050F22,#0A2555)" }} data-theme="dark">
                <div className="max-w-4xl mx-auto px-5 lg:px-8">
                    <div className="eyebrow">Contact</div>
                    <h1 className="font-serif text-4xl sm:text-5xl text-white mt-4">Communiquer avec Ménage KGD</h1>
                    <p className="text-white/75 mt-4">Choisissez le moyen qui vous convient — nous vous répondons dans les plus brefs délais.</p>
                </div>
            </section>
            <section className="max-w-4xl mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-2 gap-6">
                <a href="tel:+18195815999" data-testid="contact-phone" className="p-6 rounded-2xl border border-kgd-gold/30 bg-white hover:border-kgd-gold transition-colors">
                    <Phone className="w-5 h-5 text-kgd-gold"/>
                    <div className="font-serif text-xl text-[#071A33] mt-3">Téléphone</div>
                    <div className="text-slate-600 mt-1">819-581-5999</div>
                </a>
                <a href="mailto:info@menagekgd.ca" data-testid="contact-email" className="p-6 rounded-2xl border border-kgd-gold/30 bg-white hover:border-kgd-gold transition-colors">
                    <Mail className="w-5 h-5 text-kgd-gold"/>
                    <div className="font-serif text-xl text-[#071A33] mt-3">Courriel</div>
                    <div className="text-slate-600 mt-1">info@menagekgd.ca</div>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61575002962564" target="_blank" rel="noopener noreferrer" data-testid="contact-facebook" className="p-6 rounded-2xl border border-kgd-gold/30 bg-white hover:border-kgd-gold transition-colors">
                    <Facebook className="w-5 h-5 text-kgd-gold"/>
                    <div className="font-serif text-xl text-[#071A33] mt-3">Facebook — Ménage KGD</div>
                    <div className="text-slate-600 mt-1">Suivez-nous sur Facebook</div>
                </a>
                <div className="p-6 rounded-2xl border border-kgd-gold/30 bg-white">
                    <MapPin className="w-5 h-5 text-kgd-gold"/>
                    <div className="font-serif text-xl text-[#071A33] mt-3">Territoire</div>
                    <div className="text-slate-600 mt-1">Trois-Rivières, Shawinigan, Bécancour, Nicolet et les environs</div>
                </div>
            </section>
            <div className="max-w-4xl mx-auto px-5 lg:px-8 pb-16 text-center">
                <Link to="/soumission" className="btn-kgd" data-testid="contact-cta">Planifier mon évaluation gratuite</Link>
            </div>
        </div>
    );
}
